import { activitiesEpic as epic } from "./epic";
import { activitiesReducer as reducer } from "./reducer";

export const activitiesEpic = epic
export const activitiesReducer = reducer
